import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmLeaveDialogData {
  title?: string;
  message?: string;
}

@Component({
  selector: 'app-confirm-leave-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>{{ data.title ?? 'Unsaved Changes' }}</h2>
    <mat-dialog-content>
      <p>{{ data.message ?? 'You have unsaved changes. If you leave now, your changes will be lost.' }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="stay()">Stay</button>
      <button mat-flat-button color="warn" (click)="leave()">Leave</button>
    </mat-dialog-actions>
  `,
})
export class ConfirmLeaveDialog {
  private readonly dialogRef = inject(MatDialogRef<ConfirmLeaveDialog>);
  readonly data: ConfirmLeaveDialogData = inject(MAT_DIALOG_DATA);

  stay(): void {
    this.dialogRef.close(false);
  }

  leave(): void {
    this.dialogRef.close(true);
  }
}
